import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConstantsService } from './api-constants.service';
import { Pagination } from '~core/models/core.models';
import {
  CancellationAuditLog,
  CancellationAuditLogListParams
} from '~core/models/cancellation-audit-log.model';

@Injectable()
export class CancellationAuditLogService {
  private _http = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  list(
    invoiceId: string,
    cancellationRequestId: string,
    params?: CancellationAuditLogListParams & {
      [key: string]: any;
    }
  ): Observable<Pagination<CancellationAuditLog>> {
    return this._http.get<Pagination<CancellationAuditLog>>(
      `${this._apiConstantsService.invoicesUrl}/${invoiceId}/cancellation-requests/${cancellationRequestId}/audit-logs`,
      {
        params: {
          ...params
        } as Record<string, any>
      }
    );
  }

  read(
    invoiceId: string,
    cancellationRequestId: string,
    id: string,
    params?: CancellationAuditLogListParams
  ): Observable<CancellationAuditLog> {
    return this._http.get<CancellationAuditLog>(
      `${this._apiConstantsService.invoicesUrl}/${invoiceId}/cancellation-requests/${cancellationRequestId}/audit-logs/${id}`,
      { params }
    );
  }
}
